<script lang="ts" setup>
import ThinkingTrapChip from '@/vue/molecules/thinking-trap-chip.vue';
import ReadOnlyNonCollapsableTitle from '@/vue/molecules/read-only/helpers/read-only-non-collapsable-title.vue';

defineProps<{
  header: string;
  items: string[];
  active: boolean;
}>();
</script>

<template>
  <read-only-non-collapsable-title :header="header" :active="active">
    <div class="read-only-traps-body">
      <thinking-trap-chip v-for="item in items" :key="item" :name="item" active/>
    </div>
  </read-only-non-collapsable-title>
</template>
<style lang="scss" scoped>
.read-only-traps-body {
  display: flex;
  flex-wrap: wrap;
  gap: var(--Spacing-spacing-2);
}
</style>
